import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "add-source-buttons" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  id: "global-controls"
}
const _hoisted_4 = { id: "sound-sources" }
const _hoisted_5 = { class: "sound-sources-group" }
const _hoisted_6 = { class: "sound-sources-group" }
const _hoisted_7 = { class: "sound-sources-group" }
const _hoisted_8 = { class: "sound-sources-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Noise = _resolveComponent("Noise")!
  const _component_Oscillator = _resolveComponent("Oscillator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("label", { for: "add-sound-source" }, "Add sound source:", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.soundSrcTypes, (source, i) => {
        return (_openBlock(), _createElementBlock("button", {
          name: "add-sound-source",
          key: i,
          onClick: ($event: any) => (_ctx.handleAddSoundSrc(source))
        }, _toDisplayString(source), 9, _hoisted_2))
      }), 128))
    ]),
    (_ctx.oscillators.length > 0 || _ctx.noiseSources.length > 0)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          (!_ctx.allMuted)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMuteAll && _ctx.handleMuteAll(...args)))
              }, "Mute all"))
            : _createCommentVNode("", true),
          (_ctx.allMuted)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleUnmuteAll && _ctx.handleUnmuteAll(...args)))
              }, "Unmute all"))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.noiseSources, (noiseSource, i) => {
          return (_openBlock(), _createBlock(_component_Noise, {
            key: i,
            ref_for: true,
            ref: "noiseSourceRefs",
            audioContext: _ctx.audioContext,
            activeNoiseSource: noiseSource,
            onNoiseRemoved: _ctx.handleRemoveNoise,
            onUpdateMuted: _ctx.handleUpdateNoiseMute,
            onUpdateGain: _ctx.handleUpdateNoiseGain
          }, null, 8, ["audioContext", "activeNoiseSource", "onNoiseRemoved", "onUpdateMuted", "onUpdateGain"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lowOscillators, (oscillator, i) => {
          return (_openBlock(), _createBlock(_component_Oscillator, {
            key: i,
            ref_for: true,
            ref: "oscillatorRefs",
            audioContext: _ctx.audioContext,
            oscType: oscillator.type,
            activeOsc: oscillator,
            onOscRemoved: _ctx.handleRemoveOsc,
            onUpdateMuted: _ctx.handleUpdateOscMute,
            onUpdateGain: _ctx.handleUpdateOscGain
          }, null, 8, ["audioContext", "oscType", "activeOsc", "onOscRemoved", "onUpdateMuted", "onUpdateGain"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.midOscillators, (oscillator, i) => {
          return (_openBlock(), _createBlock(_component_Oscillator, {
            key: i,
            ref_for: true,
            ref: "oscillatorRefs",
            audioContext: _ctx.audioContext,
            oscType: oscillator.type,
            activeOsc: oscillator,
            onOscRemoved: _ctx.handleRemoveOsc,
            onUpdateMuted: _ctx.handleUpdateOscMute,
            onUpdateGain: _ctx.handleUpdateOscGain
          }, null, 8, ["audioContext", "oscType", "activeOsc", "onOscRemoved", "onUpdateMuted", "onUpdateGain"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.highOscillators, (oscillator, i) => {
          return (_openBlock(), _createBlock(_component_Oscillator, {
            key: i,
            ref_for: true,
            ref: "oscillatorRefs",
            audioContext: _ctx.audioContext,
            oscType: oscillator.type,
            activeOsc: oscillator,
            onOscRemoved: _ctx.handleRemoveOsc,
            onUpdateMuted: _ctx.handleUpdateOscMute,
            onUpdateGain: _ctx.handleUpdateOscGain
          }, null, 8, ["audioContext", "oscType", "activeOsc", "onOscRemoved", "onUpdateMuted", "onUpdateGain"]))
        }), 128))
      ])
    ])
  ], 64))
}